import React, { useState } from "react";
import {
  OFFICIAL_CLIENT_MODEL_BT,
  OFFICIAL_CLIENT_MODEL_WORKBOOK_FR,
  OFFICIAL_CLIENT_MODEL_WORKBOOK_EN,
  OFFICIAL_CLIENT_MODEL_SECTIONS,
} from "@/content/officialClientModel037.js";
import {
  CLIENT_CONTENT_RECEPTION_BT,
  getClientContentChecklist,
} from "@/content/clientContentReception045.js";
import { useKarateUi } from "@/hooks/useKarateUi.js";

/**
 * BT-045 — Boucle démo modèle officiel BT-037 (explication uniquement, aucun import réel).
 */
export function OfficialModelImportDemo045() {
  const { locale } = useKarateUi();
  const isEn = locale === "en";
  const [simulated, setSimulated] = useState(false);
  const checklist = getClientContentChecklist(locale);

  const copy = isEn
    ? {
        title: "Official client file model (BT-037) — demo loop",
        lead:
          "The official Excel model is ready for Gilles. Real import will happen only after the client file is received and validated — not in Phase 1.",
        workbookFr: "FR workbook",
        workbookEn: "EN reference workbook",
        sectionsTitle: "Expected model sections",
        noImport:
          "No automatic import, no backend, no real data — this panel explains the future path only.",
        simulate: "Simulate reception (local message only)",
        simulated:
          "[DEMO] Simulation only — no file read, no data changed. Await official file from client.",
        checklistTitle: "Client content reception checklist",
        btRef: `References: ${OFFICIAL_CLIENT_MODEL_BT}, ${CLIENT_CONTENT_RECEPTION_BT}`,
      }
    : {
        title: "Modèle fichier officiel client (BT-037) — boucle démo",
        lead:
          "Le modèle Excel officiel est prêt pour Gilles. L'import réel n'aura lieu qu'après réception et validation du fichier client — pas en Phase 1.",
        workbookFr: "Classeur FR",
        workbookEn: "Classeur référence EN",
        sectionsTitle: "Sections attendues du modèle",
        noImport:
          "Aucun import automatique, aucun backend, aucune donnée réelle — ce panneau explique seulement le chemin futur.",
        simulate: "Simuler la réception (message local seulement)",
        simulated:
          "[DÉMO] Simulation seulement — aucun fichier lu, aucune donnée modifiée. En attente du fichier officiel client.",
        checklistTitle: "Checklist réception contenu client",
        btRef: `Références : ${OFFICIAL_CLIENT_MODEL_BT}, ${CLIENT_CONTENT_RECEPTION_BT}`,
      };

  return (
    <div className="official-model-demo-045" data-testid="official-model-import-demo-045">
      <div className="info-box">
        <strong>{copy.title}</strong>
        <p>{copy.lead}</p>
        <p className="muted">{copy.noImport}</p>
        <p>
          <code>{copy.workbookFr}</code> : <strong>{OFFICIAL_CLIENT_MODEL_WORKBOOK_FR}</strong>
          <br />
          <code>{copy.workbookEn}</code> : <strong>{OFFICIAL_CLIENT_MODEL_WORKBOOK_EN}</strong>
        </p>
        <p className="muted">{copy.btRef}</p>
      </div>

      <h3>{copy.sectionsTitle}</h3>
      <ul data-testid="official-model-sections-list">
        {OFFICIAL_CLIENT_MODEL_SECTIONS.map((section) => (
          <li key={section.id}>
            <strong>{isEn ? section.sheetEn : section.sheetFr}</strong>
            {section.required ? (isEn ? " (required)" : " (obligatoire)") : ""}
          </li>
        ))}
      </ul>

      <button
        type="button"
        className="btn-secondary"
        onClick={() => setSimulated(true)}
        data-testid="official-model-simulate-btn"
      >
        {copy.simulate}
      </button>
      {simulated ? (
        <p className="import-message" role="status" data-testid="official-model-simulation-message">
          {copy.simulated}
        </p>
      ) : null}

      <h3>{copy.checklistTitle}</h3>
      <ul data-testid="client-content-reception-checklist">
        {checklist.map((item) => (
          <li key={item.id}>{item.label}</li>
        ))}
      </ul>
    </div>
  );
}
